import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'

const ListingNotFoundHead: React.FC = () => {
  const { lang, t } = useTranslation()

  const metaTitle = t('listing-detail:title_not_found') + ' | Casavo'
  const metaDescription = t('common:listing_not_found_title')

  return (
    <Head>
      <title>{metaTitle}</title>
      <meta content={metaDescription} name="description" />

      {/* Open graph */}
      <meta content={metaTitle} property="og:title" />
      <meta content={metaDescription} property="og:description" />
      <meta content={lang} property="og:locale" />
    </Head>
  )
}

export default ListingNotFoundHead
